import template from './chart.html';

/**
 * data model that chart component will expect.
 */
export class dataModel {
  constructor(key, name, color, value) {
    this.key = key;
    this.name = name;
    this.color = color;
    this.value = value;
  }
}

class ChartController {
  constructor($scope, $element, sitesService, $timeout) {
    'ngInject';

    this.$element = $element;
    this.$timeout = $timeout;
    this.colors = ['#12981c', '#d2d2d2'];
    this.id = `chart${$scope.$id}`;
    this.chart = undefined;
  }

  $onInit() {
    this.root = this.$element[0];
    this.ChartDiv = this.root.children[0];
    this.CreateChart();
  }

  $onChanges() {
    if (this.chart) {
      this.chart.dataProvider = [...(this.data || [])];
      this.chart.validateData();
      this.chart.addListener('dataUpdated', () => {
        // Resize chart after updating data to prevent it from being cropped
        this.chart.invalidateSize();
      });
    }
  }

  CreateChart() {
    this.chart = new AmCharts.makeChart(this.ChartDiv, {
      type: 'pie',
      theme: 'light',
      autoResize: true,
      percentPrecision: 1,
      innerRadius: '65%',
      pullOutRadius: 0,
      outlineAlpha: 0,
      labelRadius: -25,
      startDuration: 0,
      labelText: '',
      color: '#333',
      dataProvider: [...(this.data || [])],
      valueField: 'value',
      titleField: 'name',
      colorField: 'color',
      balloonText: "<div style='font-size:11px'><div>[[name]]</div>[[value]] - [[percents]]%</div>",

      export: {
        enabled: false,
      },
      titles: [
        {
          text: this.title,
          size: 14,
        },
      ],
    });

    if (typeof this.onSliceClick === 'function') {
      this.chart.addListener('clickSlice', this.handelSliceClick.bind(this));
    }
  }

  handelSliceClick(e) {
    const { key } = e.dataItem.dataContext;
    this.onSliceClick({ key });
  }

  showPopup(item) {
    this.chart.rollOverSlice(item);
  }

  toggleSlice(item) {
    this.chart.clickSlice(item);
  }
}

export default {
  template,
  controller: ChartController,
  controllerAs: 'chart',
  bindings: {
    data: '<',
    title: '@',
    onSliceClick: '&?',
  },
};
